export const data = {
  role: "Full Stack Developer",
  resumeLink:
    "https://drive.google.com/file/d/1HsWWCOvnJx0lfdVzrZyXOdIrP8MiH403/view?usp=sharing",
  devpost: "https://devpost.com",
  github: "https://github.com/dprasuna",
  hashnode: "https://hashnode.com/",
  about: {
    bio: "Full Stack Developer experienced in developing web applications and REST APIs. Skilled in developing websites, Good problem-solving and debugging skills with a passion for learning emerging technologies.",
    education: [
      {
        name: "Diploma in Electrical Engineering",
        location: "C.V Raman Polytechnic , Bhubaneswer",
        date: "2020 - 2023",
      },
      {
        name: "B.Tech in ComputerScience & IT",
        location: "C.V Raman Global University , Bhubaneswer",
        date: "2023 - 2026",
      },
    ],
  },
  projects: [
    {
      name: "Pharma AI MediBot – Your AI-Powered Medicine Guide",
      description:
        "🚀Pharma AI MediBot is an intelligent AI-powered platform that provides comprehensive medicine details along with natural and alternative healing solutions. It helps users make informed healthcare decisions by offering insights on Ayurvedic, Homeopathic, and Natural healing methods.🤝🔍",
      github: "https://github.com/dprasuna/Pharma-A.i-MediBot-",
      live: "https://pharma-a-i-medi-bot.vercel.app/",
      image: "song",
    },
    {
      name: "OfflinePay",
      description:
        "Welcome to OfflinePay, a cutting-edge solution revolutionizing offline payments and transactions! At OfflinePay, we believe in simplifying financial transactions, even in environments with limited or no internet access. Whether you're a business, merchant, or individual, OfflinePay ensures smooth, secure, and fast payments offline.🤝🔍",
      github: "https://github.com/dprasuna/OfflinePay-main",
      live: "https://off-pay.netlify.app/login",
      image: "tipsy",
    },
    {
      name: "GO-CHAT",
      description:
        "Chat Application with GO - REACT - Docker This repository contains a chat application built using React for the frontend and Go with WebRTC for the backend. Docker is used to containerize both the frontend and backend, making it easy to deploy the application on any machine with Docker installed. 🤝🔍",
      github: "https://github.com/dprasuna/GO-CHAT",
      live: "https://gochat-esf7.onrender.com/",
      image: "crappo",
    },
    {
      name: "CauseConnect",
      description:
        "🌟 CauseConnect CauseConnect is a dynamic web application designed to help users discover and connect with volunteer opportunities organized by local NGOs and community initiatives. Our mission is to bridge the gap between volunteers and organizations, making event discovery, registration, and participation seamless and impactful. 🤝🔍",
      github: "https://github.com/dprasuna/CauseConnect-main",
      live: "https://www.youtube.com/watch?si=uREL7hkcFf1mSodN&v=BfY_ZNdel_k&feature=youtu.be",
      image: "tweet",
    },
    {
      name: "SCRUM MANNAGEMENT",
      description:
        "The Scrum Management App 🚀 is a powerful tool designed to revolutionize project collaboration and management within the framework of Scrum. Built with React.js, this application fosters effective communication, transparency, and teamwork among project stakeholders. 🤝🔍",
      github: "https://github.com/dprasuna/SCRUM-MANNAGEMENT-APP",
      live: "https://unitydesk.netlify.app/",
      image: "tipsy",
    },

    {
      name: "Movies Hub Api Main",
      description: "Overview 🌐 The Movies Hub project is designed to provide a comprehensive collection of movie data, including details about the latest releases and timeless classics. Leveraging APIs, we ensure that our database is up-to-date and rich in content.",
      github: "https://github.com/dprasuna/Movies-Hub-Api-Main",
      live: "https://movieshub-prasuna.netlify.app/",
      image: "course",
    },

    {
      name: "SyntaxSavy",
      description: " SyntaxSavy, a versatile text data analyzer, simplifies text processing and analysis.Packed functionalities,valuable insights from textual data,for enhanced efficiency in gaining meaningful information from your text-based content.",
      github: "https://github.com/dprasuna/SyntaxSavyy-TextData-Analyzer",
      live: "https://syntaxsavvy.netlify.app/",
      image: "artsy",
    },
    {
      name: "Bharat-Heritage",
      description: "Fbonaki's Bharat-Heritage is a pioneering web-based platform that serves as a digital marketplace, designed to celebrate and preserve India's diverse cultural heritage. Our primary goal is to empower and uplift the numerous talented artisans across India. 🎨",
      github: "https://github.com/dprasuna/HACKOUT",
      live: "https://www.youtube.com/watch?v=lrxlsV304DM",
      image: "shortly",
    },
    {
      name: "AR Based Mart",
      description: "🌿 Plant Selling Mart 🌱 Welcome to the Plant Selling Mart, where the world of plants meets the convenience of online shopping! 🪴 Explore our virtual garden filled with lush greenery, vibrant blooms, and exotic species, all from the comfort of your screen. 🌸🌿",
      github: "https://github.com/dprasuna/Plant-Selling-Mart",
      live: "https://plantmart.netlify.app/#explore",
      image: "space",
    },
    {
      name: "Adventure Island",
      description: "An encyclopedia website, crafted with React and GSAP, seamlessly blends user-friendly design and dynamic animations. This powerful combination enhances user engagement, making the exploration of vast knowledge a visually appealing and interactive experience on the web.",
      github: "https://github.com/dprasuna/Adventure-Island",
      live: "https://boisterous-granita-833c42.netlify.app/",
      image: "ency",
    },
    {
      name: "Time-Mannagement-Master",
      description: "Time Management Master, 🚀 Description: Are you tired of constantly juggling tasks and struggling to keep track of your work? Look no further! Time Management Master is here to help you take control of your schedule and boost",
      github: "https://github.com/dprasuna/Time-Mannagement-Master",
      live: "https://prasuna.netlify.app/",
      image: "getset",
    },
    {
      name: "Language-Translator",
      description:
        "🌐 Language Translator: Break Down Language Barriers, 📜 Translate Files Effortlessly!Language Translator: Seamlessly translate any national or international language to another with ease! 🌎",
      github: "https://github.com/dprasuna/Language-Translator",
      live: "https://dprasuna.github.io/Language-Translator/",
      image: "song",
    },
    {
      name: "Train-Station-Master-CRUD",
      description:
        "🚄 Train Station Master CRUD Project 🛤️ Welcome to the Train Station Master project! 🚆 This project is designed to help you manage train station information with ease, allowing you to Create, Read, Update, and Delete (CRUD) records related to train stations.",
      github: "https://github.com/dprasuna/Train-Station-Master-CRUD",
      live: "https://dprasuna.github.io/Train-Station-Master-CRUD/",
      image: "tweet",
    },
    {
      name: "Daily-Dasboard",
      description: "📅 GitHub Daily Dashboard 🚀 Welcome to your one-stop daily productivity hub! The GitHub Daily Dashboard is your go-to platform for organizing your day, staying on top of your tasks, and adding a dash of fun to your work routine. Here's what you can expect",
      github: "https://github.com/dprasuna/Daily-Dasboard",
      live: "https://dprasuna.github.io/Daily-Dasboard/",
      image: "crappo",
    },
  ],
  socials: [
    { link: "https://github.com/dprasuna", name: "Github" },
    { link: "https://leetcode.com/prasunadash200/", name: "Leetcode" },
    { link: "https://twitter.com/prasunadash", name: "Twitter" },
    {
      link: "https://www.linkedin.com/in/prasuna-dash/",
      name: "Linkedin",
    },
  ],
};

export const moreinfo = {
  devpost: "https://devpost.com",
  github: "https://github.com/dprasuna",
  hackathons: [
    {
      name: "Smart india Hackathon 2023",
      project: "Bharat-Heritage",
      desc: "🌟 Empower artisans and celebrate India's cultural diversity with our web-based platform! Our mission is to bridge the recognition gap for millions of talented, yet unrecognized artisans.",
      link: "https://github.com/dprasuna/Bharat-Heritage",
      image: "artsy",
    },
    {
      name: "HackOut 2023",
      project: "FIBONAKI HERITAGE & CULTURE",
      desc: "Fbonaki's Bharat-Heritage is a pioneering web-based platform that serves as a digital marketplace, designed to celebrate and preserve India's diverse cultural heritage",
      link: "https://drive.google.com/file/d/1IuNhUgLVn26pdC8dPCrDIw_nwkkaZ5tS/view?usp=sharing",
      image: "candy",
    },
    {
      name: "EY Techathon 4.0",
      project: "AI Health Mannagement",
      desc: "Absolutely thrilled to have participated in the EY Techathon! 🚀🌐 The learning experience was unparalleled, pushing boundaries and expanding my tech horizons. Grateful for the opportunity to dive deep into innovation and collaborate with brilliant minds. ",
      link: "https://unstop.com/certificate-preview/43668e67-abaa-47bc-b1fc-4b36ac0db647?utm_campaign=site-emails&utm_medium=d2c-automated&utm_source=wow-look-at-your-certificate-ey-techathon-40",
      image: "unify",
    },
    {
      name: "IIM CALCUTTA PITCHERS",
      project: "Unify",
      desc: "Ecstatic to share my experience at the IIM Calcutta Pitchers event! 🚀🌟 Unmatched learning, pushing boundaries, and broadening my horizons in the world of business and entrepreneurship. Gratitude for the opportunity to delve into innovation, collaborating with brilliant minds at IIM Calcutta. ",
      link: "https://unstop.com/certificate-preview/91a403ad-534c-47c2-b32e-a0a44492269d?utm_campaign=site-emails&utm_medium=d2c-automated&utm_source=wow-look-at-your-certificate-pitchers",
      image: "candy",
    },
    {
      name: "Startup Grind India, Smart-o-thon 2023",
      project: "Bharat Heritage",
      desc: "Fbonaki's Bharat-Heritage is a pioneering web-based platform that serves as a digital marketplace, designed to celebrate and preserve India's diverse cultural heritage ",
      link: "https://www.startupgrind.com/startup-grind-india/",
      image: "unify",
    },
  ],
  blogs: [
    {
      name: "Python Mini-Projects",
      project: "DOCUMENTATION",
      desc: "🐍🚀 Welcome to my Python Mini-Projects Repository! This repository is a treasure trove of beginner-friendly Python projects, crafted specifically to guide newcomers through the exciting journey of learning Python programming by doing. 🌟 Each unique project resides within its own directory, providing a hands-on learning experience and practical",
      link: "https://github.com/dprasuna/PYTHON-MINI-PROJECTS",
      image: "course",
    },
    {
      name: "React-Learning-Documentation",
      project: "DOCUMENTATION",
      desc: "🚀 Welcome to my React Learning Journey 🚀 In this exciting repository, I've documented my journey of learning React! 📚 Whether you're a fellow developer seeking knowledge, or you're just curious about my coding adventures, you've come to the right place. 🤓",
      link: "https://github.com/dprasuna/React-Learning-Documentation",
      image: "course",
    },
    {
      name: "JS-DOCUMENTATION",
      project: "DOCUMENTATION",
      desc: "📚 JavaScript All Code Notes Welcome to the JavaScript All Code Notes repository! This is your one-stop resource for comprehensive documentation, code snippets, and practical examples covering a wide range of JavaScript concepts and techniques.",
      link: "https://github.com/dprasuna/JS-DOCUMENTATION",
      image: "course",
    },
  ],
  opensource: [
    {
      name: "Hacktober Fest'23",
      desc: "A simple checklist based website to Ensure effective last Moment Revision and Efficient Learning",
      link: "https://github.com/dprasuna/checklist",
      image: "linkfree",
    },
    {
      name: "GameZone",
      desc: "Report issues and get points, And added a new Game ",
      link: "https://github.com/kunjgit/GameZone",
      image: "linkfree",
    },
  ],

  Experience: [
    {
      name: "UNIVERSITY DEKHO",
      desc: " Developed a comprehensive website for University Dekho under the guidance of Sir Aaditya Singh, enhancing it with additional features. The project evolved and expanded, incorporating new functionalities to meet growing needs. This experience enriched my skills as a Full Stack Developer, fostering a passion for continuous learning and innovation in web development. ",
      link: "https://sasss.business.site/",
      image: "Exp1",
    },
    {
      name: "WAY2GO TCHNOLOGY",
      desc: "Designed and implemented a comprehensive full-stack website for Way2Go Technology, a dynamic IT service provider. The project resulted in a remarkable 25% growth for the company. The website not only showcased their services but also enhanced user engagement, contributing significantly to Way2Go Technology's success in the competitive IT industry. ",
      link: "https://way2go.tech/",
      image: "Exp2",
    },
    {
      name: "WORKSY",
      desc: "Engineered a full-stack website for Worksy, a leading job-providing company. The seamless platform significantly contributed to the company's growth, achieving a remarkable 25% increase in opportunities for job seekers and employers alike. The website's intuitive design and functionality enhanced Worksy position as a prominent player in the job market, fostering success and facilitating connections between employers and candidates. ",
      link: "https://worksy.in/",
      image: "Exp3",
    },
    {
      name: "FLUENCER",
      desc: " Crafted a comprehensive full-stack website for Fluencer, a prominent marketing company, driving a substantial 25% growth in their business. The dynamic platform showcased Fluencer's marketing prowess, fostering increased client engagement and success. The website's strategic design played a pivotal role in solidifying Fluencer's position as a leader in the marketing industry, effectively connecting clients with innovative and impactful marketing solutions.",
      link: "https://fluencerdigital.com/",
      image: "Exp4",
    },
    {
      name: "MULTIPRICING EXPERTS",
      desc: "  Engineered a targeted landing page for Multipricing Experts, amplifying their online presence and boosting ad performance. The meticulously designed page optimized user engagement, contributing to a notable 25% increase in conversion rates. Multipricing Experts now harnesses a powerful tool to captivate audiences, drive customer interest, and elevate their position in the market, ultimately achieving heightened success in their advertising endeavors. Explore the impact at multipricingexperts.com.",
      link: "https://multipricingexperts.com/",
      image: "Exp5",
    },
  ],
  
};

